import { Container, Grid } from "@mui/material";

import YourTickets from "./YourTickets/YourTickets";
import Payment from "./Payment/Payment";
import React from "react";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";

export const Checkout = () => {
  const { sm: smDown, md: mdDown } = useCssMediaQuery("down");

  return (
    <Container maxWidth="xl" sx={{ padding: smDown ? 0 : "inherit" }}>
      <Grid container spacing={"24px"} mb={8}>
        <Grid item md={6} sm={12} sx={{ width: "100%" }}>
          <YourTickets
            description={mdDown ? "Expand to view your ticket details." : ""}
            isCollapseClosed={mdDown}
          />
        </Grid>
        <Grid item md={6} sm={12} sx={{ width: "100%" }}>
          <Payment />
        </Grid>
      </Grid>
    </Container>
  );
};
